module.exports = __webpack_public_path__ + "6db251d.woff2";